module.exports = __webpack_public_path__ + "img/ecoshopIconLight.277e6a0a.png";